
import * as angular from 'angular';

export class CallBundleService {

    constructor (
        private AncillariesConstants: AncillariesConstant,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CommonsNewHttpUtilsErrorService: CommonsNewHttpUtilsErrorService,
        private CommonsGenericProxy: CommonsGenericProxy
    ) {}

    getBundle = () => {
        const checkinId = this.localStorageService.get('flowId');
        const endpoint = this.AncillariesConstants.DEFAULT_ENDPOINTS.bundleServiceURI;
        const uri = endpoint + checkinId;
        return new Promise((resolve, reject) => {
            this.CommonsGenericProxy.getGeneric(uri).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                });
        });
    };

    putBundle = (requestData) => {
        const checkinId = this.localStorageService.get('flowId');
        const endpoint = this.AncillariesConstants.DEFAULT_ENDPOINTS.putBundleURI;
        const uri = endpoint + checkinId;
        return new Promise((resolve, reject) => {
            this.CommonsGenericProxy.putGeneric(uri, requestData).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                });
        });
    };
}
CallBundleService.$inject = ['AncillariesConstants', 'localStorageService', 'CommonsNewHttpUtilsErrorService', 'CommonsGenericProxy', 'CommonsHttpServicesConstants'];
try {
    const mod = angular.module('ib-web-ancillaries-services-module');
    mod.service(
        'CallBundleService',
        CallBundleService
    );
} catch (error) {
    const mod = angular.module('ib-web-ancillaries-services-module', []);
    mod.service(
        'CallBundleService',
        CallBundleService
    );
}